import { datadogRum } from '@datadog/browser-rum';
import axios from 'axios';
import {
  DataDogTeamTags,
  DataDogTrackErrorContextType,
  TrackErrorType,
  TrackEventType,
  TrackPageViewType
} from './telemetry-types';

const isLocal = process.env.LOCAL;

const addTeamContext = (teamName: DataDogTeamTags) => {
  datadogRum.setGlobalContextProperty('team', teamName);
};

const trackEvent = (event: TrackEventType) => {
  if (isLocal) {
    console.table(event);
    return;
  }

  datadogRum.addAction(event.name, event.context);
};

const trackError = (event: TrackErrorType) => {
  if (event.error) {
    let context: DataDogTrackErrorContextType = {
      name: event.name,
      ...event.context
    };

    if (axios.isAxiosError(event.error)) {
      const axiosError = {
        message: event.error.message,
        errorType: event.error.name,
        code: event.error.code,
        status: event.error.request?.status,
        url: event.error.config?.url,
        method: event.error.config?.method,
        signalAborted: event.error.config?.signal?.aborted,
        timeout: event.error.config?.timeout,
        axiosRetryCount: event.error.config?.['axios-retry']?.retries
      };

      context = { ...context, ...axiosError };
    }

    if (isLocal) {
      console.error({ error: event.error, context });
      return;
    }

    datadogRum.addError(event.error, context);
  }
};

const trackPageView = (pageView: TrackPageViewType) => {
  if (isLocal) {
    console.table(pageView);
    return;
  }

  datadogRum.startView(pageView.viewName);
};

const updateExperimentsForTelemetry = (experimentName: string, bucketKey: string | null) => {
  try {
    const currentExperiments: object = datadogRum.getGlobalContext().experiments as object;

    const updatedExperiments = {
      ...currentExperiments,
      [experimentName]: bucketKey
    };

    if (process.env.LOCAL) {
      console.log('Experiments captured for telemetry', updatedExperiments);
      return;
    }

    datadogRum.setGlobalContextProperty('experiments', updatedExperiments);
  } catch (error) {
    datadogRum.addError('Error adding experiment name to context', {
      experimentName,
      bucketKey
    });
  }
};

export default {
  trackEvent,
  trackError,
  addTeamContext,
  trackPageView,
  updateExperimentsForTelemetry
};
